import React, { useState, useEffect } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../lib/firebase";
import "../../styles/Sidebar.css";
import Loading from "../Loader";
import { matchPath } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLandmark,
  faUserSecret,
  faUserCog,
  faCommentsDollar,
  faCircleDollarToSlot,
  faCreditCardAlt,
  faFileInvoiceDollar,
  faChartLine,
  faInfoCircle,
  faPlugCircleBolt,
  faPlugCirclePlus,
  faPlugCircleMinus,
} from "@fortawesome/free-solid-svg-icons";
import { faBitcoin } from "@fortawesome/free-brands-svg-icons";

function Sidebar() {
  const auth = getAuth();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [isAdminOpen, setIsAdminOpen] = useState(false);

  const toggleAdminDropdown = () => {
    setIsAdminOpen(!isAdminOpen);
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (authUser) => {
      if (authUser) {
        setUser(authUser);
        const userDocRef = doc(db, "users", authUser.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          setUserRole(userData.role || null);
        } else {
          console.log("No user document found");
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth]);

  if (loading) {
    return <Loading />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  const isActive = (path) => {
    const match = matchPath(path, location.pathname);
    return match !== null;
  };

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        console.log("User signed out");
        navigate("/");
      })
      .catch((error) => console.error("Error signing out: ", error));
  };

  return (
    <div className="sidebar">
      {userRole === "admin" && (
        <div className="admin-dropdown-container">
          <div className="admin-dropdown-header" onClick={toggleAdminDropdown}>
            <FontAwesomeIcon icon={faUserSecret} className="icons" /> Admin Panel
          </div>

          {isAdminOpen && (
            <ul className="admin-dropdown-list">
              <li className="admin-dropdown-item">
                <Link
                  to="/get-admin"
                  className={`admin-link ${isActive("/get-admin") ? "active" : ""}`}
                >
                  - All Users
                </Link>
              </li>
              <li className="admin-dropdown-item">
                <Link
                  to="/userdetail/add-transaction"
                  className={`admin-link ${isActive("/userdetail/add-transaction") ? "active" : ""}`}
                >
                  - Add Transaction
                </Link>
              </li>
              <li className="admin-dropdown-item">
                <Link
                  to="/plans"
                  className={`admin-link ${isActive("/plans") ? "active" : ""}`}
                >
                  - All Plans
                </Link>
              </li>
                <li className="admin-dropdown-item">
                <Link
                  to="/wallets"
                  className={`admin-link ${isActive("/wallets") ? "active" : ""}`}
                >
                  - Wallets
                </Link>
              </li>
              <li className="admin-dropdown-item">
                <Link
                  to="/accounts"
                  className={`admin-link ${isActive("/accounts") ? "active" : ""}`}
                >
                  - Accounts
                </Link>
              </li>
              <li className="admin-dropdown-item">
                <Link
                  to="/buy-coin"
                  className={`admin-link ${isActive("/buy-coin") ? "active" : ""}`}
                >
                  - Buy Coin
                </Link>
              </li>
              <li className="admin-dropdown-item">
                <Link
                  to="/admin-funding"
                  className={`admin-link ${isActive("/admin-funding") ? "active" : ""}`}
                >
                  - Admin Funding
                </Link>
              </li>
            </ul>
          )}
        </div>
      )}

      <div className="sidebar-label">Online Banking</div>

      <Link to="/" className={`routeLinks ${isActive("/") ? "active" : ""}`}>
        <FontAwesomeIcon icon={faLandmark} className="icons" /> Account Overview
      </Link>

      <Link
        to="/transactions"
        className={`routeLinks ${isActive("/transactions") ? "active" : ""}`}
      >
        <FontAwesomeIcon icon={faFileInvoiceDollar} className="icons" />{" "}
        Transactions
      </Link>

      <Link
        to="/transfer"
        className={`routeLinks ${isActive("/transfer") ? "active" : ""}`}
      >
        <FontAwesomeIcon icon={faCommentsDollar} className="icons" /> Make a
        Transfer
      </Link>

      <Link
        to="/my-card"
        className={`routeLinks ${isActive("/my-card") ? "active" : ""}`}
      >
        <FontAwesomeIcon icon={faCreditCardAlt} className="icons" /> Sky Cards
      </Link>

      <Link
        to="/loans"
        className={`routeLinks ${isActive("/loans") ? "active" : ""}`}
      >
        <FontAwesomeIcon icon={faCircleDollarToSlot} className="icons" /> Get
        Loans
      </Link>

      <div className="sidebar-label">Sky FXT</div>

      <Link
        to="/fxt"
        className={`routeLinks ${isActive("/fxt") ? "active" : ""}`}
      >
        <FontAwesomeIcon icon={faChartLine} className="icons" /> FXT Dashboard
      </Link>

      <Link
        to="/fxt/trade"
        className={`routeLinks ${isActive("/fxt/trade") ? "active" : ""}`}
      >
        <FontAwesomeIcon icon={faPlugCircleBolt} className="icons" /> Trade wit Sky
      </Link>

       <Link
        to="/fxt/deposit"
        className={`routeLinks ${isActive("/fxt/deposit") ? "active" : ""}`}
      >
        <FontAwesomeIcon icon={faPlugCirclePlus} className="icons" /> Deposit
      </Link>

       <Link
        to="/fxt/withdraw"
        className={`routeLinks ${isActive("/fxt/withdraw") ? "active" : ""}`}
      >
        <FontAwesomeIcon icon={faPlugCircleMinus} className="icons" /> Withdraw
      </Link>

         <Link
        to="/buy"
        className={`routeLinks ${isActive("/buy") ? "active" : ""}`}
      >
        <FontAwesomeIcon icon={faBitcoin} className="icons" /> Buy
      </Link>

       <Link
        to="/fxt/transactions"
        className={`routeLinks ${isActive("/fxt/transactions") ? "active" : ""}`}
      >
        <FontAwesomeIcon icon={faInfoCircle} className="icons" /> Trade History
      </Link>

      <div className="sidebar-label">Settings</div>

      <Link
        to={`/user/${user.uid}`}
        className={`routeLinks ${isActive(`/user/${user.uid}`) ? "active" : ""}`}
      >
        <FontAwesomeIcon icon={faUserCog} className="icons" /> Profile
      </Link>

       {(userRole === "admin" || userRole === "moderator") && (
        <Link
          to="/admin-funding"
          className={`routeLinks ${isActive("/admin-funding") ? "active" : ""}`}
        >
          <FontAwesomeIcon icon={faUserSecret} className="icons" /> Moderator Funding
        </Link>
      )}

      <div onClick={handleLogout} className="log-out">
        Logout
      </div>
    </div>
  );
}

export default Sidebar;
